import React from 'react';

export const ReportLayoutContext = React.createContext({});

/**
 * TODO: Keep or remove ?
 */
export function ReportLayoutProvider({ children }: { children: React.ReactNode }) {
  const value = {};

  return <ReportLayoutContext.Provider value={value}>{children}</ReportLayoutContext.Provider>;
}

export function useReportLayoutContext() {
  return React.useContext(ReportLayoutContext);
}
